<h1 class="text-center"> Distribuidor {{empresa ? empresa.nombre : '' }}</h1>

<div *ngIf="db">
    <table class="table facturas-table" style="margin: 15px 0;">
        <thead>
            <tr>
                <th colspan="7" class="text-2xl">Facturas</th>
            </tr>
            <tr>
                <th>Factura</th>
                <th>Fecha</th>
                <th>Producto</th>
                <th>Lote</th>
                <th>Cantidad</th>
                <th>Registrados</th>
                <th>Detalle</th>
                <!-- <th>Creado</th> -->
            </tr>
        </thead>
        <tbody>
            <ng-container *ngFor="let factura of db; trackBy: trackByFactura">
                <!-- fila encabezado de la factura -->
                <tr class="factura-header">
                    <td>{{ factura.numero_factura }}</td>
                    <td>{{ factura.fecha | date:'dd/MM/YYYY'}}</td>
                    <td colspan="5">
                        Productos ({{ factura.productos.length }})
                    </td>
                </tr>
                <!-- filas de productos -->
                <tr *ngFor="let prod of factura.productos; trackBy: trackByProducto"
                    [class.factura-completada]="prod.cantidad_productos==prod.trazabilidad_productos.length">
                    <td colspan="2"></td>
                    <td>{{ prod.tipo_producto.descripcion }}</td>
                    <td>{{ prod.lote }}</td>
                    <td>{{ prod.cantidad_productos }}</td>
                    <td>{{ prod.trazabilidad_productos.length }} </td>
                    <td><p-button (click)="showDialog(prod)" icon="pi pi-external-link" label="Show"></p-button></td>
                </tr>
            </ng-container>
            <ng-container *ngIf="db.length==0">
                <tr>
                    <td colspan="7" class="text-center p-4">
                        <div class="flex flex-column align-items-center">
                            <i class="pi pi-inbox text-600" style="font-size: 2rem"></i>
                            <span class="text-600 mt-2">Sin registro de facturas</span>
                        </div>
                    </td>
                </tr>
            </ng-container>
        </tbody>
        <tfoot>
            <tr>
                <td colspan="7" class="text-left p-2">
                    <span class="text-600 mt-2">Total de facturas: {{db.length}}</span>
                </td>
            </tr>
        </tfoot>
    </table>
</div>


<p-dialog header="Trazabilidad de productos" [(visible)]="visible" [modal]="true" [style]="{ width: '50vw' }"
    [draggable]="false" [resizable]="false">

    <div *ngIf="producto" class="m-0">
        <p-table [value]="producto.trazabilidad_productos" [tableStyle]="{ 'min-width': '50rem' }">
            <ng-template pTemplate="header">
                <tr>
                    <th>#</th>
                    <th>Producto</th>
                    <th>Lote</th>
                    <th>Hospital</th>
                    <th>Paciente</th>
                    <th>Medico</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-product let-index="rowIndex">
                <tr>
                    <td style="width: 5%; text-align: center;">{{index +1 }}</td>
                    <td>{{ product.tipo_producto?.descripcion }}</td>
                    <td>{{ product.lote }}</td>
                    <td>{{ product.nom_hospital }}</td>
                    <td>{{ product.nom_paciente }}</td>
                    <td>{{ product.nom_medico }}</td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="6" class="text-center p-4">
                        <div class="flex flex-column align-items-center">
                            <i class="pi pi-inbox text-600" style="font-size: 2rem"></i>
                            <span class="text-600 mt-2">Sin registro de productos con su trazabilidad</span>
                        </div>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>

</p-dialog>